var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z",
    fill: "#ABAFB1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.439 7.71812H13.6829V7.42484C13.6829 6.6388 12.9831 6 12.122 6H9.87805C9.01691 6 8.31707 6.6388 8.31707 7.42484V7.71812H6.56098C5.69984 7.71812 5 8.35692 5 9.14296V14.5752C5 15.3612 5.69984 16 6.56098 16H15.439C16.3002 16 17 15.3612 17 14.5752V9.14296C17 8.35692 16.3002 7.71812 15.439 7.71812ZM9.35772 7.42484C9.35772 7.16243 9.59057 6.94989 9.87805 6.94989H12.122C12.4094 6.94989 12.6423 7.16243 12.6423 7.42484V7.71812H9.35772V7.42484ZM6.56098 8.66801H15.439C15.7265 8.66801 15.9593 8.88055 15.9593 9.14296V10.2876H6.04065V9.14296C6.04065 8.88055 6.2735 8.66801 6.56098 8.66801ZM15.439 15.0501H6.56098C6.2735 15.0501 6.04065 14.8376 6.04065 14.5752V11.2375H15.9593V14.5752C15.9593 14.8376 15.7265 15.0501 15.439 15.0501Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.05C16.5505 21.05 21.05 16.5505 21.05 11C21.05 5.44954 16.5505 0.95 11 0.95C5.44954 0.95 0.95 5.44954 0.95 11C0.95 16.5505 5.44954 21.05 11 21.05Z",
    stroke: "white",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamDefault);
export default __webpack_public_path__ + "static/media/team-default.5540afa3a34d3b62334970472ccc2924.svg";
export { ForwardRef as ReactComponent };